export const CHART_COLORS = ["#459FC5", "#559C52", "#D3BD4E", "#DA4949"];

export const REVIEW_STATUS = [
  null,
  "Success",
  "Needs manual review",
  "Broken document",
  "Resolved manually",
];

export const REVIEW_COLORS = [null, "#00BB00", "#FFD300", "#DA1818", "#00BB00"];

export const API_COLORS = ["#00BB00", "#DA1818"];

export const LEGAL_ENTITY_TYPE = [
  { label: "Corporation", value: "1" },
  { label: "Sole Proprietorship", value: "2" },
  { label: "LLC", value: "3" },
  { label: "Partnership", value: "4" },
  { label: "Other", value: "5" },
];

export const FILE_TYPE = [null, "Application", "Bank Statements"];

export const ENTITY_STATUS = [
  { label: "Good Standing", value: "1" },
  { label: "Bad Standing", value: "2" },
  { label: "Unknown", value: "3" },
];
